import axios from "axios";
import generalStore from "../../components/Stores/SurveyStore"
import store from "../../components/Stores/IbsSurveyStore";
import { IDENTITY_CONFIG_LIVE } from "../../Enums/authConstants";
import { getAllTableData, getIBSPlanResults, getAvailableSurveysForAllPlansIBS } from "../../control";
import {SetCultureFromSurvey, setCurrentDBSurvey, GetMandateData} from "./DbService";
import { set, toJS } from "mobx";
import { CURRENT_DATA_YEAR, SurveyTypeURL, SelectCombosIBS } from "../../Enums/constants";
import sharedStore from "../../components/Stores/SharedStore";
import { setActualErrorCommentValue, redirectToPage } from "../../helpers";
import { saveAs as importedSaveAs } from 'file-saver';
import { toast } from "react-toastify";
import { isLGPS } from "../../ibsHelper";
import { Product } from "../../Enums/ibsConstants"
import IbsSurveyStore from "../../components/Stores/IbsSurveyStore";
import PabsSurveyStore from "../../components/Stores/SurveyStore";
import { getCookie } from "../Authentication/AuthHelper";

const defaultDataYear = sharedStore.currentDataYear;
const localTemplateUploadRoot = process.env.REACT_APP_TEMPLATE_UPLOAD_ROOT || `http://${window.location.hostname}:5289`;
const templateUrl = process.env.NODE_ENV === `production` ?
    (sharedStore.identityConfig === IDENTITY_CONFIG_LIVE ? `https://templateupload.cembenchmarking.com/tool` : `https://webupload.cembenchmarking.com/tool`) :
    localTemplateUploadRoot;

export function checkIfAnalyst() {
    let oidcTokenNew = localStorage.getItem("oidc.user:https://identity.cembenchmarking.com/core/:" + sharedStore.identityConfig.clientId)
    let idp = JSON.parse(oidcTokenNew)?.profile.idp;
   
    if (idp == "CEM.EmployeeIdentityAdfs") { //CEM.EmployeeIdentityAdfs
        //is an analyst
        return true
    }

    return false
}

export function setAnalystInfo() {
    if (checkIfAnalyst()) {
        store.accountInfo = { UserRoleID: 3, IsAdmin: true }

        let lastOpenedPlan = localStorage.getItem("lastOpenedPlanID");
        let lastOpenedProduct = localStorage.getItem("lastOpenedProductType");
        var productType = lastOpenedProduct == "DB" ? 1 : 2
        generalStore.availablePlanProducts = [{ PlanId: lastOpenedPlan, ProductID: productType, UserRoleID: 3 }]
    }
}

export async function getIbsAccountInfo() {
    if (checkIfAnalyst()) return null
    if (store.accountInfo) return store.accountInfo
    const config = {
    
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        
        params: {
            
        }
    };

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetAccountInfo", config)
        .then(response => {
            store.accountInfo = JSON.parse(response.data);
        })
        .catch(error => {
            console.log(error);
        });

}

export async function getAvailablePlans() {
    if (checkIfAnalyst()) return null
    const config = {
    
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
        }
    };

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetAvailablePlans", config)
        .then(response => {
            
            let resp = JSON.parse(response.data)
            if (checkIfAnalyst()) {
                let lastOpenedPlan = localStorage.getItem("lastOpenedPlanID");
                let lastOpenedProduct = localStorage.getItem("lastOpenedProductType");
                var productType = lastOpenedProduct == "DB" ? 1 : 2
                generalStore.availablePlanProducts = [{ PlanId: lastOpenedPlan, ProductID: productType, UserID: store.accountInfo.UserID, UserRoleID: 3 }]
            } else {
                generalStore.availablePlanProducts = resp;
            }
    });
}
    export async function getProductAccess() {
        var planId = store.accountInfo.PlanID;

        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + getCookie("access_token")
            },
            params: {
                planId: planId
            }
        }
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetProductAccess", config)
        .then(response => {
            let productAccess = response.data; 
            if (!store.accountInfo.HasDBAccess && productAccess.includes(1)) {
                store.accountInfo.HasDBAccess = true
            } if (!store.accountInfo.HasDCAccess && productAccess.includes(2)) {
                store.accountInfo.HasDCAccess = true
            }

            //var flag = false;
            //// Checking whether a survey for current year needs to be created
            //if (store.accountInfo.HasDCAccess && store.accountInfo.DefinedContribution == null) {
            //    fetch = true;
            //}
            //else if (store.accountInfo.HasDBAccess && store.accountInfo.DefinedBenefit == null) {
            //    fetch = true;
            //} 
            //else {
            //    //no access
            //    console.log("No survey???", store.accountInfo)
            //    //window.location.replace("/");

            //}
        })
        .catch(error => {
            console.log(error);
        });
    }

export async function createDcProduct(planIdParam) {
    var planId = planIdParam
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            planId: planId 
        }

    };

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/CreateDcProduct", config)
        .then(response => {
            var newSurveyId = response.data;
            //getAvailableSurveysIBS(0, planIdParam);
            localStorage.setItem("lastOpenedSurveyIdCacheDC", newSurveyId)
            getAvailableSurveysForAllPlansIBS()
            getAvailableSurveysIBS(0, planIdParam, "DC");
            changeSurveyIBS(newSurveyId, planIdParam, "DC");
            redirectToPage("TermsandConditions")

        })
        .catch(error => {
            console.log(error);
        });
}

export async function createDbProduct(planIdParam) {
    //var planId = store.accountInfo.PlanID;
    let planId = planIdParam
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            planId: planId
        }

    };

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/CreateDbProduct", config)
        .then(response => {
            console.log(response);
            var newSurveyId = response.data;
            localStorage.setItem("lastOpenedSurveyIdCacheDB", newSurveyId)

            //getAvailableSurveysIBS(0, planId);
            getAvailableSurveysForAllPlansIBS()
            getAvailableSurveysIBS(0, planIdParam, "DB");
            changeSurveyIBS(newSurveyId, planIdParam, "DB");
            redirectToPage("TermsandConditions")

        })
        .catch(error => {
            console.log(error);
        });
}

export async function ibsNavigate() {
    //seems not to be used
    if (!store.accountInfo) {
        await getIbsAccountInfo();
    }
    try {
        const DBaccess = store.accountInfo.HasDBAccess;
        const DCaccess = store.accountInfo.HasDCAccess;
        window.location.replace("/ibs/home")
    } catch (ex) {
        window.location.replace("/ibs/home")
    }
}

export function getResponseData() {
    var surveyId;
    surveyId = parseInt(localStorage.getItem("lastOpenedSurveyIdCacheDC"));
    if (!surveyId) {
        surveyId = store.currentSurvey.SurveyID; //i think this differs if its coming from laundromat or avail surveys 
    }

    if (surveyId) {
        const config = {
            headers: {
               Accept: 'application/json',
               Authorization: 'Bearer ' + getCookie("access_token")
            },
            params: {
                surveyId: surveyId
    
            },
    
        };
        axios
            .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetSurveyResponses", config)
            .then(response => {
                store.allResponses = JSON.parse(response.data)

            })
            .catch(error => {
                store.databaseConnection = false;
                console.log(error);
            });
    } else {
        console.log("No survey ID found")
    }
}
/**
 * Change the visible survey to the one chosen by user 
 * @param {any} surveyId
 */
export async function changeSurveyIBS(surveyId, orgId, productId) {

    if (productId === "DB") {
        localStorage.setItem("lastOpenedSurveyIdCacheDB", surveyId);
        localStorage.setItem("lastOpenedProductType", productId);
    }
    if (productId === "DC") {
        localStorage.setItem("lastOpenedSurveyIdCacheDC", surveyId);
        localStorage.setItem("lastOpenedProductType", productId);
    }

    localStorage.setItem("lastOpenedPlanID", orgId);

    await setCurrentIBSSurvey(defaultDataYear, surveyId, productId);
  
}

async function setSurvey(product) {
    var lastOpenedSurveyIdCache
    if (product === "DB") {
        lastOpenedSurveyIdCache = localStorage.getItem("lastOpenedSurveyIdCacheDB");

    } else if (product === "DC") {
        lastOpenedSurveyIdCache = localStorage.getItem("lastOpenedSurveyIdCacheDC");
    } else if (store.accountInfo.UserRoleID != 3) {
        // if no product create new survey
        handleNoSurvey(null, sharedStore.currentDataYear)
    }

    if (lastOpenedSurveyIdCache) { // load cached survey if exists (only for analysts since they have access to all surveys)
        await setCurrentIBSSurvey(defaultDataYear, lastOpenedSurveyIdCache, product)
    } else {
        if (product === "DB") {
            await setCurrentIBSSurvey(defaultDataYear, null, product)
        } else if (product === "DC") {
            await setCurrentIBSSurvey(defaultDataYear, null, product)
        }
    }
}

/**
 * Requests the opened survey's details
 * */
export async function setCurrentIBSSurvey(defaultDataYear, surveyId, product) {
    if (product === "DB") {
        surveyId = localStorage.getItem("lastOpenedSurveyIdCacheDB")
        localStorage.removeItem("lastOpenedSurveyIdCacheDC");
        await setCurrentDBSurvey(defaultDataYear, surveyId)
    }
    if (product === "DC") {
        surveyId = localStorage.getItem("lastOpenedSurveyIdCacheDC")
        localStorage.removeItem("lastOpenedSurveyIdCacheDB");
        await setCurrentDCSurvey(defaultDataYear, surveyId)
    }
}

/**
 * Requests the opened survey's details
 * */
export async function setCurrentDCSurvey(defaultDataYear, surveyId) {
    var survey
    var result
    if (surveyId) {

        result = generalStore.allAvailableSurveys.filter(survey => survey.SurveyID == surveyId);
    } else if (generalStore.allAvailableSurveys.length>0) {

        // get most recent survey if no specified surveyId
        result = generalStore.allAvailableSurveys.reduce(function (prev, curr) {
            return (prev.DataYear > curr.DataYear) ? prev : curr
        })
    } else {
        console.log('no surveys available DC')
    }
    
    if (Array.isArray(result)) {
        survey = result[0]
    } else {
        survey = result
    }
    if (!survey) handleNoSurvey("DC", defaultDataYear)

        
    //in some situation here, we must create a new survey!! if it does not exist it seems
    try {
        var previouslyLoadedSurvey;
        if (store.currentSurvey) { previouslyLoadedSurvey = store.currentSurvey }
        store.currentSurvey = survey;

        if (!store.currentSurvey) {
            if (!window.location.href.includes("/dc/home")) window.location.replace("/dc/home")
        }
        else {
            if (!window.location.href.includes("/dc")) {
                if (window.location.href.includes("/ibs/home")) {
                    window.location.replace("/dc/home")
                }
                else if (!window.location.href.includes("/dc/home")) {
                    let page = store.currentSurvey?.isAgreed || store.currentSurvey?.DataYear < CURRENT_DATA_YEAR ? "PlanInfo" : "TermsAndConditions"
                    window.location.replace("/dc/" + page)
                } else {
                    window.location.replace("/dc/home")
                }

            }
            localStorage.setItem("lastOpenedSurveyIdCacheDC", JSON.stringify(store.currentSurvey.SurveyID))
        }
        store.sessionChanges = store.currentSurvey?.NumChanges;

    } catch (e) {
        console.log('Missing survey: ', e);
    }
    if (store.currentSurvey) {
        //do this every time for latest data
        
        await SetCultureFromSurvey(store.currentSurvey.SurveyID);

        await Promise.all([
            getResponseData(),
            getAllTableData(),
            getPlanDesignData(),
            getIBSPlanResults(),
            getAllSurveyErrorsDC()])
            .catch((error) => {
                console.error(error.message);
            });

        if (store.currentSurvey.DataYear) {
            let parsedDataYear = parseInt(survey.DataYear);
            if (!Number.isNaN(parsedDataYear)) generalStore.currentYear = parsedDataYear;
        }

        generalStore.loadingSurvey = false;
    }
    
}

export function handleNoSurvey(product, dataYear) {
    console.log("No survey found for current data year redirecting...")
    console.log("User must create new survey for current data year: ", sharedStore.currentDataYear)
    //window.location.replace("/ibs/home")
}

export function getTableData(tableName) {
    var surveyId = store.currentSurvey.SurveyID;
    const config = {
        headers: {
           Accept: 'application/json',
           Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            tableName: tableName, 
            surveyId: surveyId
        }
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetTableData", config)
        .then(response => {
            var res = JSON.parse(response.data);
            if (res.length > 0) {
                store.allTableResponses[tableName] = res;
            }
            else {
                store.allTableResponses[tableName] = [];
            }
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(tableName, error);
        });

}

export function makeAssetMandateMapping() {
    if (store.allTableResponses["MappingAM"] || !(store.allTableResponses["AssetClassCategories"]) || !(store.allTableResponses["MandateStyles"])) {
        return;
    }

    let toReturn = {};

    for (let assetClass of store.allTableResponses["AssetClassCategories"]) {
        toReturn[assetClass.AssetID] = [];
    }

    for (let mandateStyle of store.allTableResponses["MandateStyles"]) {

        let toPush = {
            StyleID: mandateStyle.StyleID,
            StyleName: mandateStyle.StyleName
        }
        if (toReturn[mandateStyle.AssetClassID]) {
            toReturn[mandateStyle.AssetClassID].push(toPush);
        }
        
    }
    store.allTableResponses["MappingAM"] = toReturn;
}

export async function getMandateStyles() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
        }
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetAllMandateStyles", config)
        .then(response => {
            var res = JSON.parse(response.data)

            if (store.allTableResponses["MandateStyles"]) {
                store.allTableResponses["MandateStyles"] = [];
            }
            if (res.length > 0) store.allTableResponses["MandateStyles"] = JSON.parse(response.data);
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log("MandateStyles", error);
        });

}

export async function getAssetClasses() {
    // Don't grab the table if it already exists. The asset classes table is static, or close to it.
    if (store.allTableResponses["AssetClassCategories"] && store.allTableResponses["AssetClassCategories"].length > 0) return;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
        }
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetAllAssetClasses", config)
        .then(response => {
            var res = JSON.parse(response.data)

            if (store.allTableResponses["AssetClassCategories"]) {
                store.allTableResponses["AssetClassCategories"] = [];
            }
            if (store.allTableResponses["AssetClassCategoriesMap"]) {
                store.allTableResponses["AssetClassCategoriesMap"] = [];
            }

            if (res.length > 0) {
                store.allTableResponses["AssetClassCategories"] = JSON.parse(response.data);
                let acNames = {};
                if (store.allTableResponses["AssetClassCategories"]) {
                    for (let obj of store.allTableResponses["AssetClassCategories"]) {
                        acNames[obj.AssetName] = obj.AssetID;
                    }
                }
        
                store.allTableResponses["AssetClassCategoriesMap"] = acNames;
            }

        })
        .catch(error => {
            store.databaseConnection = false;
            console.log("AssetClassCategories", error);
        });

}

export function saveInputValueDC(inputName, value, tableName, rowId) {
    const surveyId = store.currentSurvey.SurveyID;
    const isAnalyst = store.accountInfo?.UserRoleID == 3;
    const page = generalStore.currentLandedPage;
    if (!checkIfAnalyst()) store.sessionChanges = store.sessionChanges + 1

    if (rowId == 0 && tableName != "PlanDesign") {
        rowId = null
    }

    if (value === "null") {
        value = null;
    }

    if (tableName === "Options" && inputName === "AssetClassName") {
        if (store.allTableResponses["AssetClassCategoriesMap"] && store.allTableResponses["AssetClassCategoriesMap"][value]) {
            value = store.allTableResponses["AssetClassCategoriesMap"][value];
        }
        else {
            value = "";
        }
        inputName = "AssetClassID";
    }
    if (tableName === "Options" && inputName === "MandateStyleName" ) {
        try {
            let rowNum = store.allTableResponses[tableName].findIndex(row => row.OptionID == rowId);
            let rowAC = store.allTableResponses[tableName][rowNum].AssetClassName;
            let rowACID = store.allTableResponses["AssetClassCategoriesMap"][rowAC];
            value = store.allTableResponses["MappingAM"][rowACID].filter(obj => {
                return obj.StyleName === value
            });
            if (value && value.length > 0) {
                value = value[0].StyleID;
            }
            else {
                value = "";
            }
        }
        catch {
            value = "";
        }
        inputName = "StyleID";
    }
    

    let toastId = null;
    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: sharedStore.identityConfig.clientRoot + "api/DcSurvey/SaveResponse",
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token"),
        },
        params: {
            QuestionName: inputName,
            tableName: tableName,
            page: page,
            surveyId: surveyId,
            rowId: rowId,
            isAnalyst: isAnalyst
        },
        data: JSON.stringify(value)
    };
    axios.request(config)
        .then(response => {
            store.checkedSurvey = false;
            if (!checkIfAnalyst()) store.sessionChanges =store.sessionChanges+1;

            if (inputName == 'PlanDesignEmployeesWithDB' || inputName == 'PlanDesignHasDifferentRates') {
                getPlanDesignData();
            }

            if (tableName == 'Options') {
                getTableData("TDBalancedFunds");
                if (inputName == "BMDesc") {
                    getTableData("Options");

                }
            }

            // Old code for managing single errors, delete me if present past May 2023
            /*
            let errorPageTable = generalStore.currentLandedPage;
            if (generalStore.allValidationErrorsList[errorPageTable] && generalStore.allValidationErrorsList[errorPageTable].length > 0) {
                var index = generalStore.allValidationErrorsList[errorPageTable].findIndex(obj => {
                    if (tableName) return obj.QuestionName.toLowerCase() == inputName.toLowerCase() && obj.RowID === rowId;
                    else return obj.QuestionName.toLowerCase() == inputName.toLowerCase();
                })
            }
            if (index >= 0 && generalStore.allValidationErrorsList && generalStore.allValidationErrorsList[errorPageTable]) {
                generalStore.allValidationErrorsList[errorPageTable].splice(index, 1);
            }

            //if there was an error on this input previously, remove it since the survey will need to be revalidated to redetermine the error status of that input 
            //add to error list if a error is returned, ie error message exists

            var error;
            if (generalStore.surveyTypeUrl === SurveyTypeURL.PABS || generalStore.surveyTypeUrl === SurveyTypeURL.PABS_UK) {
                error = JSON.parse(response.data)[0];

            } else {
                error = JSON.parse(response.data)
            }
            console.error(error);
            if (error && error.ErrorMessage !== null && error.RuleStatus !== "Pass") {
                generalStore.allValidationErrorsList[errorPageTable]?.push(error);
            }
            */

            var ErrorMap = JSON.parse(response.data);
            var pagesWithErrors = Object.keys(ErrorMap);
            var errorPage = generalStore.currentURL.split("/").slice(-1)[0].trim().replace(/([a-z])([A-Z])/g, '$1_$2');
            var curErrorPage = errorPage.replace("_", "").toLowerCase();
            for (let key in ErrorMap) {
                ErrorMap[key.replace("_", "").toLowerCase()] = ErrorMap[key];
                delete ErrorMap[key];
            }
            var errors = ErrorMap[curErrorPage];
            var storeErrors;
            if (curErrorPage in generalStore.allValidationErrorsList) storeErrors = JSON.parse(JSON.stringify(generalStore.allValidationErrorsList[curErrorPage]))

            if (typeof errors !== "undefined" && errors !== null) {
                errors.forEach(error => {
                    // Lets do the same thing as the PABS stuff
                    if (storeErrors && storeErrors.length > 0) {
                        var index = storeErrors.findIndex(obj => {
                            if (error.QuestionName === "CheckTotalPolicy") { error.RowID = 1 }
                            if (error.QuestionName === "CheckTotalAssetMix") { error.RowID = 1 }
                            if (tableName) {
                                return obj.QuestionName.toLowerCase() == error.QuestionName.toLowerCase() && obj.RowID === error.RowID;
                            }
                            else {
                                return obj.QuestionName.toLowerCase() == error.QuestionName.toLowerCase();
                            }
                        })
                    }
                    var replace = true;
                    if (index >= 0) {
                        if (error.IsRemove || error.RuleStatus == "Pass" || error.ErrorId != storeErrors[index].ErrorId) {
                            storeErrors.splice(index, 1)
                        }
                        else
                            replace = false;
                    }
                    if (replace && !error.IsRemove && error.RuleStatus != "Pass") {
                        storeErrors.push(error)
                    }
                })
                generalStore.allValidationErrorsList[curErrorPage] = storeErrors;
            }

        })
        .catch(error => {
            store.databaseConnection = false;
            if (toastId) {
                toast.update(toastId, {
                    render: "Error saving.  Please refresh the page and try again.",
                    type: toast.TYPE.INFO,
                    className: "red-notif",
                    autoClose: 10000
                });
            } else {
                toast("Error saving.  Please refresh the page and try again.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    draggable: false,
                    autoClose: 4000,
                    hideProgressBar: true,
                    className: "red-notif"
                });
            }
        });

}

export function validateDCSurvey() {
    var surveyId = store.currentSurvey.SurveyID;
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            isAnalyst: isAnalystUser
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/ValidateDCSurvey", config)
        .then(response => {
            generalStore.loadingErrorSummaryDone = true;
            console.log(response.data);

            var errorSummary = JSON.parse(response.data);
            store.checkedSurvey = true;

            generalStore.surveyAllErrors = errorSummary.list;
            getAllSurveyErrorsDC()
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export function submitDCSurvey() {
    var surveyId = store.currentSurvey.SurveyID;
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            isAnalyst: isAnalystUser
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/SubmitDCSurvey", config)
        .then(async response => {
            store.currentSurvey.SurveyStatusID = 2;
            getIBSPlanResults()

            if(isAnalystUser)
                await GetSurveySubmissionsByDate();
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export function unlockDCSurvey() {
    var surveyId = store.currentSurvey.SurveyID;
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            isAnalyst: isAnalystUser
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/UnlockDCSurvey", config)
        .then(response => {
            store.currentSurvey.SurveyStatusID = null;

        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export function getAllSelectCombos() {
    const config = {
        headers: {
           Accept: 'application/json',
           Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetAllSelectCombos", config)
        .then(response => {
            var testDict = {}
            JSON.parse(response.data).forEach(function (item, index) {
                testDict[item.PlanTypeName] =item.PlanTypeID
            });
            const keys = Object.keys(testDict) //dropdown options
            store.selectCombosTest = testDict
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });

}
export function getOptionsModalDefaults() {
    const dataYear = store.currentSurvey.DataYear;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            providerName: IbsSurveyStore.tempOptionsRowInfo.ProviderName,
            optionName: IbsSurveyStore.tempOptionsRowInfo.OptionName, 
            dataYear: dataYear
        },
    }

    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetDefaultOptionCombo", config)
        .then(response => {
            let resp = JSON.parse(response.data)
            if (resp.DefaultAssetClassID) store.tempOptionsRowInfo.AssetCategoryID = resp.DefaultAssetClassID
            else store.tempOptionsRowInfo.AssetCategoryID  = 11
            let assetName = Object.keys(store.allTableResponses["AssetClassCategoriesMap"]).find(key => store.allTableResponses["AssetClassCategoriesMap"][key] === store.tempOptionsRowInfo.AssetCategoryID);
            store.tempOptionsRowInfo.AssetCategoryName = assetName
            store.tempOptionsRowInfo.MandateStyleID = resp.DefaultStyleID
            //
            store.legalStyles = store.allTableResponses["MappingAM"][store.tempOptionsRowInfo.AssetCategoryID]

            let styleMatch = store.legalStyles.find(obj => {
                return obj.StyleID == store.tempOptionsRowInfo.MandateStyleID
            })
            store.tempOptionsRowInfo.MandateStyleName = styleMatch.StyleName 


        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });

}

export async function insertEmptyRow(tableName) {
    var surveyId = store.currentSurvey.SurveyID;

    const config = {
           headers: {
               Accept: 'application/json',
               Authorization: 'Bearer ' + getCookie("access_token")
           },
        params: {
            surveyId: surveyId,
            table: tableName
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/InsertRow", config)
        .then(response => {
            let responseData = JSON.parse(response.data)
            if (!checkIfAnalyst()) store.sessionChanges = store.sessionChanges + 1;


            if (tableName == "Options") {
                responseData.OptionID
                //let optionID = responseData.OptionID
                //saveInputValueDC("ProviderName", store.tempOptionsRowInfo.ProviderName, "Options", optionID)
                //saveInputValueDC("OptionName", store.tempOptionsRowInfo.OptionName, "Options", optionID)
                //saveInputValueDC("AssetClassID", store.tempOptionsRowInfo.AssetCategoryID, "Options", optionID)
                //saveInputValueDC("StyleID", store.tempOptionsRowInfo.MandateStyleID, "Options", optionID)

                //responseData.ProviderName = store.tempOptionsRowInfo.ProviderName
                //responseData.OptionName = store.tempOptionsRowInfo.OptionName
                //responseData.AssetClassName = store.tempOptionsRowInfo.AssetCategoryName
                //responseData.MandateStyleName = store.tempOptionsRowInfo.MandateStyleName

                ////just get option row here instead and push it?
                //autoPopOptionRow(optionID)
                ////getTableData("Options") //instead just append the row data to the table, should rerender then too... otherwise inefficient
                //clearDictionary(store.tempOptionsRowInfo)
                //store.showOptionRowModal = false;
                //store.editOptionModal = false;
                //store.tempOptionsRowInfo.OptionID = optionID
                
            } else {
                //add empty row to array
                store.allTableResponses[tableName].push(responseData)
                if (store.lastRowAdded) {
                    let element = document.getElementById(store.lastRowAdded);
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }

           
        })
        .catch(error => {
            console.log(error);
        });
}


export async function getPlanDesignData() {
    const surveyId = store.currentSurvey.SurveyID;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetPlanDesigns", config)
        .then(response => {
            store.allTableResponses["PlanDesign"] = JSON.parse(response.data)
        })
        .catch(error => {
            console.log("plan design err", error);
        });

}

export async function getAllSurveyErrorsDC() {
    await getPageErrorsDC("Plan_Info");
    await getPageErrorsDC("Admin_Costs");
    await getPageErrorsDC("Admin_Services");
    await getPageErrorsDC("Options");
    await getPageErrorsDC("Td_Balanced");
    await getPageErrorsDC("Plan_Design");
    await getPageErrorsDC("Fiduciary");
    await getPageErrorsDC("Employer_Stock");
}

export async function getPageErrorsDC(page) {

    // Overrides QuestionName based on rule name
    // Format of entries "RuleName": "NewQuestionName"

    const surveyId = store.currentSurvey.SurveyID;
        
    let errorListForPage;
    const config = {
        headers: {
           Accept: 'application/json',
           Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            page: page,
            surveyId: surveyId,
        },

    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetPreLoadPageErrors", config)
        .then(response => {
            errorListForPage = JSON.parse(response.data);
            let pageName = page.replace("_", "").toLowerCase();

            generalStore.allValidationErrorsList[pageName] = errorListForPage;
        })
        .catch(error => {
            console.log(error, page);
        });

}

export function AddErrorCommentsDC(qname, errorExplanation, rowID) {
    var surveyId = store.currentSurvey.SurveyID;

    var rowId;
    if (rowId == 0) {
        rowId = null;

    }
    var errorListForPage;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            errorExplanation: errorExplanation, 
            questionName: qname, 
            rowId: rowID
        },

    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/UpdateErrorExplanation", config)
        .then(response => {
            setActualErrorCommentValue()

        })
        .catch(error => {
        });

}

export function AddErrorCommentsByIdDC(errorId, errorExplanation) {
    var surveyId = store.currentSurvey.SurveyID

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            errorExplanation: errorExplanation,
            errorId: errorId
        },

    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/UpdateErrorExplanationById", config)
        .then(response => {
            setActualErrorCommentValue()
        })
        .catch(error => {
        });
}

export async function getSurveyLaundromatList() {
    let product
    if (generalStore.surveyTypeUrl===SurveyTypeURL.DC) product = "DC"
    else if (generalStore.surveyTypeUrl === SurveyTypeURL.DB) product = "DB"
    
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetSurveyLaundryList", config)
        .then(response => {
            store.surveyListDisplay = JSON.parse(response.data);
            store.loadingSurvey = false;

        })
        .catch(error => {
            store.databaseConnection = false;
            console.log('set survey error', error);
        });
    
    
    //setSurvey(product);
}

export async function getSurveyHistoricalSurveys(currentYear) {
    let product
    if (generalStore.surveyTypeUrl === SurveyTypeURL.DC) product = "DC"
    else if (generalStore.surveyTypeUrl === SurveyTypeURL.DB) product = "DB"

    if (!currentYear) {
        currentYear = CURRENT_DATA_YEAR;
    }

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            currentYear: currentYear
        }
    }
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetHistoricalSurveys", config)
        .then(response => {
            store.surveysHistorical = JSON.parse(response.data);

        })
        .catch(error => {
            store.databaseConnection = false;
            console.log('set survey error', error);
        });


    //setSurvey(product);
}

export async function getSurveyCleaners() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetSurveyCleaners", config)
        .then(response => {
            store.surveyCleanersIBS = JSON.parse(response.data).filter(cleaner => cleaner.isIbs);
            PabsSurveyStore.surveyCleanersPABS = JSON.parse(response.data).filter(cleaner => cleaner.isPabs);
            if (Array.isArray(store.surveyCleanersIBS)) {

                store.surveyCleanersMapIBS = {};
                store.surveyCleanersIBS.forEach((cleaner) => {
                    let userID = cleaner?.id ?? null;
                    if (userID !== null) {
                        store.surveyCleanersMapIBS[userID] = cleaner;
                    }
                });
            }
            if (Array.isArray(PabsSurveyStore.surveyCleanersPABS)) {

                PabsSurveyStore.surveyCleanersMapPABS = {};
                PabsSurveyStore.surveyCleanersPABS.forEach((cleaner) => {
                    let userID = cleaner?.id ?? null;
                    if (userID !== null) {
                        PabsSurveyStore.surveyCleanersMapPABS[userID] = cleaner;
                    }
                });
            }
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log('set survey error', error);
        });

    //setSurvey(product);
}


export async function GetRecentActivityList() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetRecentActivityList", config)
        .then(response => {
            store.recentActivityList = JSON.parse(response.data);
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log('recentActivityList fetch error', error);
        });
}


export async function GetProductStatsDB() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetProductStatsDB", config)
        .then(response => {
            store.productStatsDB = JSON.parse(response.data);
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log('productStatsDB fetch error', error);
        });
}

export async function GetProductStatsDC() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetProductStatsDC", config)
        .then(response => {
            store.productStatsDC = JSON.parse(response.data);
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log('productStatsDC fetch error', error);
        });
}

export async function GetSurveySubmissionsByDate() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetSurveySubmissionsByDateLast30Days", config)
        .then(response => {
            const rawData = JSON.parse(response.data);
            let data = {};
            
            const products = [Product.DB, Product.DC];
            products.forEach(product => {
                data[product] = [];
                rawData[product].forEach(rawDatum => {
                    data[product].push({
                        "Submissions": rawDatum.Submissions,
                        "DateCompletedWithoutTime": new Date(rawDatum.DateCompletedWithoutTime),
                    })
                })
                data[product].sort((a, b) => a.DateCompletedWithoutTime.valueOf() - b.DateCompletedWithoutTime.valueOf())
            })
            
            store.surveySubmissionsByDate = data;
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log('surveySubmissionsByDate fetch error', error);
        });
}

/**
 * Get all available surveys available to the user's organization for easy access to previous years' data
 * */
export async function getAvailableSurveysIBS(surveyIdRequest, planIdRequest, product = undefined) {
    if (!planIdRequest) var planIdRequest = store.accountInfo.PlanID;
    if (!surveyIdRequest) var surveyIdRequest = 0;
    //if cache has the orgid and survey then set it 
    //if nothing in cache then get the org id from accountinfo and the survey is 0

    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    let planIdCached = localStorage.getItem("lastOpenedPlanID")
    
    //if (!isAnalystUser) {
    //    planIdRequest = store.accountInfo.PlanID
    //} else
    let cookie = getCookie("access_token")
    if (cookie==null) {
        window.location.replace("/ibs/signin");
    }
    if (planIdCached) {
        planIdRequest = planIdCached
    }
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            planID: planIdRequest
        }
    }

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/getAvailableSurveys", config)
        .then(response => {
            var responseData = JSON.parse(response.data);
            var dbSurveyCount = (responseData.filter(ibsSurvey => ibsSurvey.ProductID == 1)).length;
            var dcSurveyCount = (responseData.filter(ibsSurvey => ibsSurvey.ProductID == 2)).length;

            var autoGenerateProductType = dcSurveyCount >= dbSurveyCount ? 2 : 1;

            // if missing Surveys, create one that has null surveyID?
            var currentYear = sharedStore.currentDataYear;
            generalStore.availableSurveys=[]
            generalStore.availableSurveys = responseData;
            if (checkIfAnalyst()) generalStore.allAvailableSurveys = generalStore.availableSurveys
            var lastOpenedPlanID = localStorage.getItem("lastOpenedPlanID");
            
            if (!product) {
                if (generalStore.availableSurveys.filter(survey => survey.ProductID == 2).length > 0) product = "DC"
                if (generalStore.availableSurveys.filter(survey => survey.ProductID == 1).length > 0) product = "DB"

                console.log("1. Product is:", product, toJS(generalStore.availableSurveys))

            }
           

            setSurvey(product);

        })
        .catch(error => {
            console.log(error);
        });
}
export async function getAvailableSurveysForAllIBSPlans(planIdRequestRaw) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            planID: planIdRequestRaw
        }
    }

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/getAvailableSurveys", config)
        .then(response => {
            var responseData = JSON.parse(response.data);
            responseData.forEach(element => {
                generalStore.allAvailableSurveys.push(element) 

            });

        })
        .catch(error => {
            console.log(error);
        });
}

export async function getTemplateData() {
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    if (!isAnalystUser) {
        return null;
    }
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    getTemplateManagers(rootUrl, surveyID);

    getTemplateDropdowns(rootUrl, surveyID);
    getTemplateExisting(rootUrl, surveyID);
    getTemplateInProcess(rootUrl, surveyID);
    getTemplateLinkEntries(rootUrl, surveyID);
}

export async function getTemplateDataTables() {
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    if (!isAnalystUser) {
        return null;
    }
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    getTemplateExisting(rootUrl, surveyID);
    getTemplateInProcess(rootUrl, surveyID);
}

export async function uploadDataTemplateFiles(files) {
    try {
        let surveyID = store.currentSurvey.SurveyID;
        let rootUrl = templateUrl;

        const formData = new FormData();
        files.forEach(file => {
            formData.append("dataTemplateFiles", file);
        });

        const headers = new Headers();
        headers.append('Authorization', `Bearer ${getCookie("access_token")}`);

        const options = {
            method: 'POST',
            headers,
            body: formData
        }
        let requestUrl = `${rootUrl}/Template/Data/Mandates/${surveyID}/UploadMultiple`;
        
        const request = new Request(requestUrl, options);
        const response = await fetch(request, { mode: 'cors', cache: 'no-cache' });
        if (response.ok) {
            return true;
        } else {
            if (response.status >= 400 && response.status <= 499) {
                return false;
            } else if (response.status >= 500 && response.status <= 599) {
                return false;
            }
            return false;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
}

export async function getTemplateFile(rowId, isInProcess = false) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const headers = new Headers();
    headers.append('Authorization', `Bearer ${getCookie("access_token")}`);

    const options = {
        method: 'GET',
        headers
    }
    let requestUrl = `${rootUrl}/Template/Data/Mandates/${surveyID}/${isInProcess ? 'InProcess' : 'Existing'}/${rowId}/File`;
    
    const request = new Request(requestUrl, options);
    const response = await fetch(request, { mode: 'cors', cache: 'no-cache' });
    if (response.ok) {
        if (response.status !== 204) {
            return response.blob();
        } else {
            return null;
        }
    } else {
        if (response.status >= 400 && response.status <= 499) {
            return null;
        } else if (response.status >= 500 && response.status <= 599) {
            return null;
        }
        return null;
    }
}

export async function getTemplateDropdowns(rootUrl, surveyID) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .get(`${rootUrl}/Template/Data/Meta/${surveyID}/ValidDropdownCombo`, config)
        .then(response => {
            if (response.data && Object.keys(response.data)?.length >= 0) {
                store.templateDropdownData = response.data;
            }
        })
        .catch(error => {
            console.log('get template data error', error);
        });
}

export async function getTemplateManagers(rootUrl) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .get(`${rootUrl}/Template/Data/Meta/NormalizedManagerNameData`, config)
        .then(response => {
            if (response.data && Object.keys(response.data)?.length >= 0) {
                store.templateNormalizedManagerDropdownData = response.data;
            }
        })
        .catch(error => {
            console.log('get template managers error', error);
        });
}

export async function getTemplateExisting(rootUrl, surveyID) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .get(`${rootUrl}/Template/Data/Mandates/${surveyID}/Existing`, config)
        .then(response => {
            if (response.data && Object.keys(response.data)?.length >= 0) {
                store.templateExisting = response.data;
            }
        })
        .catch(error => {
            console.log('get template data error', error);
        });
}

export async function getTemplateInProcess(rootUrl, surveyID, rowId = null) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .get(`${rootUrl}/Template/Data/Mandates/${surveyID}/InProcess`, config)
        .then(response => {
            if (response.data && response.data.length >= 0) {
                if (rowId) {
                    let rowToUpdateIdx = store.templateInProcess.findIndex(template => template.rowId === rowId);
                    let updatedRow = response.data.find(template => template.rowId === rowId);
                    set(store.templateInProcess, rowToUpdateIdx, { ...updatedRow, adding: store.templateInProcess[rowToUpdateIdx].adding, removing: store.templateInProcess[rowToUpdateIdx].removing })
                } else {
                    if (store.templateInProcess.length > 0) {
                        store.templateInProcess = response.data.map(template => {
                            let templateRow = { 'adding': false, 'removing': false, ...template, managerId: template.managerId === null ? -1 : template.managerId };
                            if (store.templateInProcess.findIndex(existingTemplate => existingTemplate.rowId === template.rowId) === -1) {
                                templateRow.newRow = true;
                            }

                            return templateRow;
                        });
                    } else {
                        store.templateInProcess = response.data.map(template => ({ 'adding': false, 'removing': false, ...template }));
                    }
                }
            }
        })
        .catch(error => {
            console.log('get template data error', error);
        });
}

export async function getTemplateLinkEntries(rootUrl, surveyID) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .get(`${rootUrl}/Template/Data/Meta/${surveyID}/LinkEntries`, config)
        .then(response => {
            if (response.data && Object.keys(response.data)?.length >= 0) {
                store.templateLinkEntries = response.data;
            }
        })
        .catch(error => {
            console.log('get template data error', error);
        });
}

export async function linkTemplate(rowId, mandateId) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .post(`${rootUrl}/Template/Data/Mandates/${surveyID}/Link/${rowId}/${mandateId}`, null, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                getTemplateInProcess(rootUrl, surveyID, rowId);
            }
        })
        .catch(error => {
            console.log('link template error', error);
        });
}

export async function unlinkTemplate(rowId) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .post(`${rootUrl}/Template/Data/Mandates/${surveyID}/Unlink/${rowId}`, null, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                getTemplateDataTables();
            }
        })
        .catch(error => {
            console.log('link template error', error);
        });
}

export async function updateExistingMandateCleaned(row) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    var object = { isClean: row.isClean }

    await axios
        .patch(`${rootUrl}/Template/Data/Mandates/${surveyID}/UpdateExistingMandateCleaned/${row.mandateId}`, object, config)
        .then(response => {
            if (response.status == 200) {
                return true;
            } else {
                getTemplateDataTables();
                GetMandateData()
            }
        })
        .catch(error => {
            console.log('update template error', error);
        });

}

export async function updateTemplate(row) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    const formData = new FormData();
    formData.append("entry", JSON.stringify(row));

    await axios
        .patch(`${rootUrl}/Template/Data/Mandates/${surveyID}/${row.inProcess ? 'InProcess' : 'Existing'}`, row, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                if (row.inProcess) {
                    getTemplateInProcess(rootUrl, surveyID, row.rowId);
                    /* update mobx store instead of calling api */
                } else {
                    getTemplateExisting(rootUrl, surveyID);
                    
                }
                GetMandateData()
                return true;
            } else {
                getTemplateDataTables();
                GetMandateData()
            }
        })
        .catch(error => {
            console.log('update template error', error);
        });
}

export async function getScrapedData(rowId) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    return await axios
        .get(`${rootUrl}/Template/Data/Mandates/${surveyID}/InProcess/${rowId}/ScrapedData`, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                let { data } = response;

                let infoRows = [];

                Object.keys(data.Info)
                    .forEach(key => {
                        infoRows.push(`<tr><th>${key}</th><td>${data.Info[key]}</td></tr>`)
                    });

                let mandatesRows = [];
                Object.keys(data.Mandates)
                    // .sort()
                    .forEach(key => {
                        mandatesRows.push(`<tr><th>${key}</th><td>${data.Mandates[key]}</td></tr>`)
                    });

                let TemplatesRows = [];
                Object.keys(data.Templates)
                    // .sort()
                    .forEach(key => {
                        TemplatesRows.push(`<tr><th>${key}</th><td>${data.Templates[key]}</td></tr>`)
                    });

                let tableHtml = `<style>
                table {
                    font-size: 13px;
                    border-radius: 0px;
                    border-collapse: collapse;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
                }

                tr.emptyRow {
                    height: 1rem;
                    border-top: 1px solid #DFDFDF;
                }

                table th {
                    padding: 0.2rem !important;
                    padding-left: 0.3rem !important;
                    border: none;
                    background-color: #F5F5FF;
                    font-weight: 400;
                    padding: 0.2rem !important;
                    text-align: left;
                }

                table td {
                    padding: 0.2rem;
                    padding-left: 0.3rem;
                    cursor: text;
                }
                </style>
                <table>
                    <tbody>
                        <tr><th><strong>Info</strong></th><td></td></tr>
                        ${infoRows.join('').split("\n").join("<br>")}
                        <tr class="emptyRow"></tr>
                        <tr>
                            <th>File</th><td>${data.RowData.File}</td>
                        </tr>
                        <tr>
                            <th>Messages</th><td>${data.RowData.Messages.split("\n").join("<br>")}</td>
                        </tr>
                        <tr class="emptyRow"></tr>
                        <tr><th><strong>Mandates</strong></th><td></td></tr>
                        ${mandatesRows.join('').split("\n").join("<br>")}
                        <tr class="emptyRow"></tr>
                        <tr><th><strong>Templates</strong></th><td></td></tr>
                        ${TemplatesRows.join('').split("\n").join("<br>")}
                        <tr class="emptyRow"></tr>
                    </tbody>
                    </table>`

                return tableHtml;
            }
        })
        .catch(error => {
            console.log('link template error', error);
        });
}

export async function getCompareData(rowId, mandateId, isExisting) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    return await axios
        .get(`${rootUrl}/Template/Data/Mandates/${surveyID}/${isExisting ? 'Existing' : 'InProcess'}/${rowId}/${isExisting ? 'ExistingData' : 'ScrapedData' }/Compare/${mandateId}`, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                let { data } = response;

                let currentDataYear = store.currentSurvey.DataYear;
                let displayDataYear = isLGPS() ? currentDataYear + 1 : currentDataYear;

                let infoRows = [];
                Object.keys(data.Info)
                    .forEach(key => {
                        infoRows.push(`<tr><th>${key}</th><td>${data.Info[key][0]}</td><td>${data.Info[key][1]}</td><td>${data.Info[key][2]}</td></tr>`)
                    });

                let tableHtml = `<style>
                table {
                    font-size: 13px;
                    border-radius: 0px;
                    border-collapse: collapse;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
                }

                tr.emptyRow {
                    height: 1rem;
                    border-top: 1px solid #DFDFDF;
                }

                table th {
                    padding: 0.2rem !important;
                    padding-left: 0.3rem !important;
                    border: none;
                    background-color: #F5F5FF;
                    font-weight: 400;
                    padding: 0.2rem !important;
                    text-align: left;
                }

                table td {
                    padding: 0.2rem;
                    padding-left: 0.3rem;
                    cursor: text;
                }
                </style>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th><strong>This, ${displayDataYear}</strong></th>
                            <th><strong>Compare, ${displayDataYear}</strong></th>
                            <th><strong>Compare, ${displayDataYear - 1}</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><th><strong>Info</strong></th><td></td><td></td><td></td></tr>
                        ${infoRows.join('').split("\n").join("<br>")}
                    </tbody>
                    </table>`

                return tableHtml;
            }
        })
        .catch(error => {
            console.log('link template error', error);
        });
}

export async function actionSingle(rowId, action) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .post(`${rootUrl}/Template/Data/Mandates/${surveyID}/Action/${rowId}/${action}`, null, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                if (store.templateInProcess.length > 0) {
                    if (response?.data?.mandateId) {
                        /* added row goes back into the table */
                        let templateIdx = store.templateInProcess.findIndex(template => template.rowId === rowId);
                        store.templateInProcess[templateIdx] = { ...response.data };
                    } else {
                        /* added row has ben moved to the new table */
                        store.templateInProcess = store.templateInProcess.filter(template => template.rowId !== rowId);
                        getTemplateExisting(rootUrl, surveyID);
                    }
                } else {
                    getTemplateDataTables();
                }
                GetMandateData();
            }
        })
        .catch(error => {
            templateErrorHandler(error);
        });
}

export async function actionMultiple(actions) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .post(`${rootUrl}/Template/Data/Mandates/${surveyID}/ActionMultiple`, actions, config)
        .then(() => {
            getTemplateDataTables();
            GetMandateData();
        })
        .catch(error => {
            templateErrorHandler(error);
        });
}

export async function deleteMultipleExistingMandates(mandateIds) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .delete(`${rootUrl}/Template/Data/Mandates/${surveyID}/Existing/`, { data: mandateIds, ...config })
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                getTemplateExisting(rootUrl, surveyID);
                GetMandateData();
                return true;
            }
        })
        .catch(error => {
            templateErrorHandler(error);
        });
}

export async function clearMultipleExistingMandates(mandateIds) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .patch(`${rootUrl}/Template/Data/Mandates/${surveyID}/Existing/ClearValues`, mandateIds, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                getTemplateExisting(rootUrl, surveyID);
                GetMandateData();
                return true;
            }
        })
        .catch(error => {
            templateErrorHandler(error);
        });
}

export async function removeExisting(mandateId) {
    let surveyID = store.currentSurvey.SurveyID;
    let rootUrl = templateUrl;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    }

    await axios
        .delete(`${rootUrl}/Template/Data/Mandates/${surveyID}/Existing/${mandateId}`, config)
        .then(response => {
            if (response.status >= 200 && response.status <= 200) {
                getTemplateExisting(rootUrl, surveyID);
                GetMandateData();
                return true;
            }
        })
        .catch(error => {
            templateErrorHandler(error);
        });
}

function templateErrorHandler(error) {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log('update template error', error.response.data);
        let toastId = toast('There was an error performing this action.', {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
            draggable: false,
            autoClose: true,
            hideProgressBar: true,
            className: "red-notif"
        });
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }
}

export function deleteRowFromTableDC(rowId, tableName) {
    // var surveyId = store.accountInfo.DefinedBenefit.SurveyID;
    var surveyId = store.currentSurvey.SurveyID;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            table: tableName,
            surveyId: surveyId,
            rowId: rowId
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/DeleteRow", config)
        .then(response => {
            var result
            if (tableName == "Options") {
                getTableData("TDBalancedFunds");
                result = store.allTableResponses[tableName].findIndex(row => row.OptionID == rowId);
            }
            else result = store.allTableResponses[tableName].findIndex(row => row.RowID == rowId);
            if (result>-1) store.allTableResponses[tableName].splice(result, 1)

        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });

}

export async function updateSurveyInfo(surveyId, fieldName, value, isDate = false) {
    const surveyInfo = toJS(store.surveyListDisplay.find(survey => survey.SurveyID == surveyId) ?? store?.surveysHistorical?.find(survey => survey.SurveyID == surveyId));
    const newValue = value == "null" ? null : value;
    surveyInfo[fieldName] = newValue;
    const bearerToken = "Bearer " + getCookie("access_token");
    await axios({
        method: "post",
        url: sharedStore.identityConfig.clientRoot + "api/DbSurvey/UpdateSurveyInformation",
        data: JSON.stringify(value),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            "Authorization": bearerToken
        },
        params: {
            surveyId: surveyId,
            questionName: fieldName
        }
    })
        .then(response => {
            //assume if successful, update the surveyListDisplay
            const storeSurvey = store?.surveyListDisplay?.find(survey => survey.SurveyID == surveyId);
            const historicalSurvey = store?.surveysHistorical?.find(survey => survey.SurveyID == surveyId);

            if (typeof storeSurvey !== "undefined" && storeSurvey !== null) {
                storeSurvey[fieldName] = newValue;
            }
            if (typeof historicalSurvey !== "undefined" && historicalSurvey !== null) {
                historicalSurvey[fieldName] = newValue;
            }
            
            //do the same with the currentsurvey store if it is the same
            if (!isDate && store.currentSurvey.SurveyID == surveyId) {
                store.currentSurvey[fieldName] = newValue;
            }
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

// Copy of updateSurveyInfo, assumes plan info is also stored in surveyInfo
// This should be changed
export async function updatePlanInfo(surveyId, fieldName, value, isDate = false) {
    const surveyInfo = toJS(store.surveyListDisplay.find(survey => survey.SurveyID == surveyId) ?? store?.surveysHistorical?.find(survey => survey.SurveyID == surveyId));
    const newValue = value == "null" ? null : value;

    let planId = surveyInfo.PlanID;
    if (planId == null) {
        return;
    }

    surveyInfo[fieldName] = newValue;

    const bearerToken = "Bearer " + getCookie("access_token");
    await axios({
        method: "post",
        url: sharedStore.identityConfig.clientRoot + "api/DbSurvey/UpdatePlanInformation",
        data: JSON.stringify(value),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            "Authorization": bearerToken
        },
        params: {
            planId: planId,
            questionName: fieldName
        }
    })
        .then(response => {
            //assume if successful, update the surveyListDisplay
            const storeSurvey = store?.surveyListDisplay?.find(survey => survey.SurveyID == surveyId);
            const historicalSurvey = store?.surveysHistorical?.find(survey => survey.SurveyID == surveyId);

            if (typeof storeSurvey !== "undefined" && storeSurvey !== null) {
                storeSurvey[fieldName] = newValue;
            }
            if (typeof historicalSurvey !== "undefined" && historicalSurvey !== null) {
                historicalSurvey[fieldName] = newValue;
            }

            //do the same with the currentsurvey store if it is the same
            if (!isDate && store.currentSurvey.SurveyID == surveyId) {
                store.currentSurvey[fieldName] = newValue;
            }
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}


const getProductType = (productId) => {
    return productId === 1 ? "DB"
        : productId === 2 ? "DC"
            : null;
}

export async function getMorningstarHelpFile() {
    const apiEndpoint = "/api/DcSurvey/getMorningstarHelpFile";

    const config = {
        responseType: 'arraybuffer',
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    };

    await axios
        .get(apiEndpoint, config)
        .then(response => {
            const contentType = response.headers["content-type"].trim();
            const returnedFileName = `CEM_FAQ-External_Party_Data.pdf`;

            const blob = new Blob([response.data], { type: contentType });

            importedSaveAs(blob, returnedFileName);
        })
        .catch(error => {
            console.log(error);
        });
}

export async function getHelpFileIbs() {
    const productId = store.currentSurvey.ProductID;
    let productType = getProductType(productId); // "DB" or "DC"
    
    const apiEndpoint =
        productType === "DB" ? "/api/DbSurvey/getHelpFile"
            : productType === "DC" ? "/api/DcSurvey/getHelpFile"
            : ""; // Unexpected productType
    
    if(apiEndpoint === "") {
        console.error(`Attempting to call getExcelTemplateIbs with productType: ${productType}`);
        return;
    }

    const countryID = store.currentSurvey.CountryID;
    const config = {
        responseType: 'arraybuffer',
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            countryId: countryID
        }
    };

    await axios
        .get(apiEndpoint, config)
        .then(response => {
            const contentType = response.headers["content-type"].trim();
            const returnedFileName = `CEM_${productType}_Instructions.pdf`;

            const blob = new Blob([response.data], { type: contentType });

            importedSaveAs(blob, returnedFileName);
        })
        .catch(error => {
            console.log(error);
        });
}

export async function getExcelTemplateIbs() {
    const productId = store.currentSurvey.ProductID;
    let productType = getProductType(productId); // "DB" or "DC"
    
    const apiEndpoint =
        productType === "DB" ? "/api/DbSurvey/getExcelTemplate"
            : productType === "DC" ? "/api/DcSurvey/getExcelTemplate"
            : ""; // Unexpected productType
    if(apiEndpoint === "") {
        console.error(`Attempting to call getExcelTemplateIbs with productType: ${productType}`);
        return;
    }

    let partnershipId = store.currentSurvey.PlanPartnershipID;
    let countryID = store.currentSurvey.CountryID;
    const config = {
        responseType: 'arraybuffer',
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            partnershipId: partnershipId,
            countryId: countryID
        }
    };
    
    await axios
        .get(apiEndpoint, config)
        .then(response => {
            const contentType = response.headers["content-type"].trim();
            
            let returnedFileName = undefined;
            switch (contentType) {
                case "application/vnd.ms-excel":
                    returnedFileName = "CEM Survey.xls";
                    break;
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    returnedFileName = "CEM Survey.xlsx";
                    break;
                default:
                    return; // just don't do anything
            }
            
            const blob = new Blob([response.data], { type: contentType });
            
            importedSaveAs(blob, returnedFileName);
        })
        .catch(error => {
            console.log(error);
        });
}

export function getDCResultsUniverse() {
    if (store.currentSurvey) var surveyId = store.currentSurvey.SurveyID;
    if (store.currentSurvey) var dataYear = store.currentSurvey.DataYear;
    if (!store.currentSurvey) return null
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId, 
            dataYear: dataYear
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetDCResultsUniverse", config)
        .then(response => {
            let data = JSON.parse(response.data)
            store.universeResult = {
                "totalNetReturn": data[0].toFixed(1), "netValueAdded": data[1].toFixed(1), 
                "grossValueAdded": data[2].toFixed(1), "totalGrossReturn": data[3].toFixed(1), 
                "totalCostBps": data[4].toFixed(1), "totalCostPerParticipant": data[5].toFixed(1)
            }

        
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export function getDCResultsParticipant() {
    if (store.currentSurvey) {
        var surveyId = store.currentSurvey.SurveyID;
        var dataYear = store.currentSurvey.DataYear
    }
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyID: surveyId, 
            dataYear : dataYear
        }
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetDCResultsParticipant", config)
        .then(response => {
            store.participantResult = response.data
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}
export async function autoPopOptionRow(optionID) {
    
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            rowId: optionID,
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/AutoPopOptionRow", config)
        .then(response => {
            store.lastRowAdded = optionID
            let prepopData = JSON.parse(response.data)
            if (prepopData) store.allTableResponses["Options"].push(prepopData)
            if (store.lastRowAdded) {
                let element = document.getElementById(store.lastRowAdded);
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        })
        .catch(error => {
            console.log("autopop err", error);
        });

}
export async function saveOptionsModal(providerName, fundName, morningStarId, assetClassID, styleID, optionID, ticker, shareClass, useSecLend) {
    const surveyId = store.currentSurvey.SurveyID;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            providerName: providerName,
            fundName: fundName, 
            assetClassID: assetClassID,
            styleID: styleID,
            surveyID: surveyId,
            rowId: optionID,
            morningStarId: morningStarId,
            ticker: ticker,
            shareClass: shareClass,
            useSecLend: useSecLend
        },
    };

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/SaveOptionsModalValues", config)
        .then(response => {
            let prepopData = JSON.parse(response.data.value)
            getTableData("TDBalancedFunds");
            if (!checkIfAnalyst()) store.sessionChanges = store.sessionChanges + 1;
            if (!optionID && prepopData) {
                store.lastRowAdded = prepopData.OptionID
                store.allTableResponses["Options"].push(prepopData)
                if (store.lastRowAdded) {
                    let element = document.getElementById(store.lastRowAdded);
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
            else {
                let changedRow = store.allTableResponses["Options"].findIndex(obj => obj.OptionID == optionID)
                //let catName = AssetCategoryIDs[catID]
                if (changedRow >= 0) Object.assign(store.allTableResponses["Options"][changedRow],
                {
                    ProviderName: prepopData.ProviderName,
                    OptionName: prepopData.OptionName,
                    AssetClassName: prepopData.AssetClassName, 
                    MandateStyleName: prepopData.MandateStyleName,
                    Ticker: ticker,
                    MorningStarId: morningStarId,
                    ShareClass: shareClass,
                    UseSecLend: useSecLend
                    })
                store.lastRowAdded = store.allTableResponses["Options"][changedRow].OptionID


            }
           
        })
        .catch(error => {
            console.log("autopop err", error);
        });

}
export async function previewMorningStarData(morningStarId) {
    var surveyId = store.currentSurvey.SurveyID;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyID: surveyId,
            morningStarId: morningStarId,
        },
    };

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/PreviewMorningStarData", config)
        .then(response => {
            let prepopData = JSON.parse(response.data)
            if (typeof prepopData != "undefined" && prepopData != null) {
                // Let just update the edit option?
                store.tempOptionsRowInfo.ProviderName = prepopData.ProviderName;
                store.tempOptionsRowInfo.OptionName = prepopData.OptionName;

                store.legalStyles = Array.from(store.allTableResponses["MappingAM"][prepopData.AssetClassID], (obj) => { return obj.StyleName; });
                store.tempOptionsRowInfo.AssetCategoryID = prepopData.AssetClassID;
                store.tempOptionsRowInfo.AssetCategoryName = prepopData.AssetClassName;
                store.tempOptionsRowInfo.MandateStyleID = prepopData.StyleID;
                store.tempOptionsRowInfo.MandateStyleName = prepopData.MandateStyleName;
                store.tempOptionsRowInfo.Message = "";
            } else {
                store.tempOptionsRowInfo.Message = "Morningstar Id could not be found, please provide the information below";
                //store.tempOptionsRowInfo.ProviderName = "";
                //store.tempOptionsRowInfo.OptionName = "";

                //store.tempOptionsRowInfo.AssetCategoryID = 0;
                //store.tempOptionsRowInfo.AssetCategoryName = "";
                //store.tempOptionsRowInfo.MandateStyleID = 0;
                //store.tempOptionsRowInfo.MandateStyleName = "";
            }
        })
        .catch(error => {
            console.log("autopop err", error);
        });

}
export async function getDropdownOptions(fieldName) {
    
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            fieldName: fieldName
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetDropdownOptionsForField", config)
        .then(response => {
            //now dynamic
            let dropdownValues = JSON.parse(response.data)
            if (dropdownValues && dropdownValues[0]){
                let index = Object.keys(dropdownValues[0])[0] //key name
                let optionValue = Object.keys(dropdownValues[0])[1] //value name
                var optionsArray = JSON.parse(response.data).reduce(
                    (obj, item) => Object.assign(obj, { [item[index]]: item[optionValue] }), {});
                const newOptions = { 0: "", ...optionsArray }; //add a blank option
                SelectCombosIBS[fieldName] = newOptions

            }
            
        })
        .catch(error => {
            console.log("autopop err", error);
        });

}
export async function setTermsAndConditionsInfo(firstName, lastName, isAgreed) {
    let userId = store.accountInfo.UserID
    let surveyId = store.currentSurvey.SurveyID
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            firstName: firstName, 
            lastName: lastName, 
            isAgreed: isAgreed,
            userID: userId, 
            surveyID: surveyId
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/IbsSurvey/SetTermsAndConditions", config)
        .then(response => {
            //currently specific to EnhancedInternal... make more dynamic
            store.currentSurvey["FirstName"] = firstName
            store.currentSurvey["LastName"] = lastName
            store.currentSurvey["isAgreed"] = isAgreed
        })
        .catch(error => {
            console.log("autopop err", error);
        });

}
export async function registerUser(userName, password, email, country, planTypeID, planSponsor) {
    if (!planTypeID) planTypeID = 1
    const config = {
        headers: {
            Accept: 'application/json'
        },
        params: {
            UserName: userName,
            Password: password,
            Email: email,
            CountryID: country,
            PlanSponsorName: planSponsor,
            PlanTypeID: planTypeID
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PreSurvey/RegisterUser", config)
        .then(response => {
            //currently specific to EnhancedInternal... make more dynamic
            window.location.href = "/verifyemail";
        })
        .catch(error => {
            console.log("autopop err", error);
        });

}

export async function getAllCountries() {

    const config = {
        headers: {
            Accept: 'application/json'
        },
        params: {
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PreSurvey/GetAllCountries", config)
        .then(response => {
            store.countriesForRegistration = response.data

        })
        .catch(error => {
            console.log("err", error);
        });

}


export async function activateAccount(email, username) {
    const config = {
        headers: {
            Accept: 'application/json'
        },
        params: {
            queryEmail: email,
            queryUsername: username,
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/PreSurvey/ActivateAccount", config)
        .then(response => {
            //response depends, there are 3 variations though

        })
        .catch(error => {
            console.log("err", error);
        });

}

export async function secretValidateDB() {
    let surveyId = store?.currentSurvey?.SurveyID;
    if (typeof surveyId === "undefined" || surveyId === null) {
        return;
    }
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
            
        },
        params: {
            surveyID: surveyId
        },
    };

    // TODO: generalStore.allValidationErrorsList[generalStore.currentLandedPage] Errors are zero here
    await axios
        .patch(sharedStore.identityConfig.clientRoot + "api/DbSurvey/SecretValidateDBSurvey", null ,config)
        .then(response => {
        })
        .catch(error => {
            console.log("autopop err", error);
        });
    // TODO: generalStore.allValidationErrorsList[generalStore.currentLandedPage] Errors magically appear
}

export async function secretValidateDC() {
    let surveyId = store?.currentSurvey?.SurveyID;
    if (typeof surveyId === "undefined" || surveyId === null) {
        return;
    }

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
            
        },
        params: {
            surveyID: surveyId
        },
    };
    await axios
        .post(sharedStore.identityConfig.clientRoot + "api/DcSurvey/SecretValidateDCSurvey", null, config)
        .then(response => {
        })
        .catch(error => {
        });

}

export async function secretRulesRefresh() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token"),
        },
        params: {
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/SecretRulesRefresh", config)
        .then(response => {
        })
        .catch(error => {
        });

}

export async function clearErrors(surveyId) {

    if (surveyId === null || typeof surveyId === "undefined") {
        return;
    }

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token"),
        },
        params: {
            surveyID: surveyId
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/ClearErrors", config)
        .then(response => {
        })
        .catch(error => {
        });
}

export async function initialMorningstarMatch(surveyId) {
    if (typeof surveyId === "undefined" || surveyId === null) {
        surveyId = store?.currentSurvey?.SurveyID;
    }
    if (typeof surveyId === "undefined" || surveyId === null) {
        return;
    }

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")

        },
        params: {
            surveyID: surveyId
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/InitialMorningstarMatch", config)
        .then(response => {
        })
        .catch(error => {
        });
}

export async function morningstarMatch(surveyId) {
    if (typeof surveyId === "undefined" || surveyId === null) {
        surveyId = store?.currentSurvey?.SurveyID;
    }
    if (typeof surveyId === "undefined" || surveyId === null) {
        return;
    }

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")

        },
        params: {
            surveyID: surveyId
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/MorningstarMatch", config)
        .then(response => {
        })
        .catch(error => {
        });
}